// import myStore from "../stores/store";
import { runInAction } from "mobx";

export function stater(store,code) {
  return {
    linker: {
      set value(val){
        // myStore.formStore.updateHappened();
        store.setState({ [code]:val });
      },
      get value(){
        return typeof store.state[code] === 'undefined'?'':store.state[code];
      }
    }
  }
}

export function custom(store,code,callback) {
  return {
    linker: {
      set value(val){
        // myStore.formStore.updateHappened();
        if(callback) {
          runInAction(()=>{
            const newVal=typeof val === 'undefined' ? '' : val;
            if(store[code] != newVal) {
              store[code] = typeof val === 'undefined' ? '' : val;
              callback(store[code]);
            }
          });
        } else {
          store[code] = typeof val === 'undefined' ? '' : val;
        }
      },
      get value(){
        return typeof store[code] === 'undefined'?'':store[code];
      }
    }
  }
}

export function checkbox(store,code,callback) {
  return {
    checked: parseInt(store[code]) === 1 || store[code] === true?true:false,
    onChange: (e) => {
      console.log("changin checkbox!");
      if(callback) {
        runInAction(()=>{
          if (e.target.checked) {
            store[code] = 1;
          } else {
            store[code] = 0;
          }
          callback(store[code]);
        });
      } else {
        if (e.target.checked) {
          store[code] = 1;
        } else {
          store[code] = 0;
        }
      }
    }
  }
}

export function input(store,code,callback) {
  return {
    value: typeof store[code] === 'undefined'?'':store[code],
    onChange: (e) => {
      if(callback) {
        runInAction(()=>{
          store[code] = e.target.value;
          callback(e.target.value);
        });
      } else {
        // console.log('e.target.value',e.target.value);
        store[code] = e.target.value;
      }
    }
  }
}